export const APP_NAME = 'PRizmo | 管理画面';
export const APP_KEY = 'admin';
export const BASE_URL = process.env.REACT_APP_API_ENDPOINT;
export const FRONT_URL = process.env.REACT_APP_FRONT_ENDPOINT;
export const CDN_ENDPOINT = process.env.REACT_APP_CDN_ENDPOINT;
export const ENV = process.env.REACT_APP_ENVIRONMENT;
export const REACT_APP_BASE_PATH = process.env.REACT_APP_BASE_PATH;

export const PRIZMO_JS_URL = {
    1 : "https://prizmosa.blob.core.windows.net/prizmo-public/prizmo.js",
    2 : `${CDN_ENDPOINT}/widgetjs/prizmo_v2.js?v=202610061`,
}

export const PRIZMO_JS_UNIQUE_PATH = `${CDN_ENDPOINT}/widgetjs/unique/`;

export const AI_NAME = "AI";

export const UNKNOWN_ERROR_DETAIL = "サーバーへの通信に失敗しました。";
export const TIMEOUT_ERROR_DETAIL = "通信がタイムアウトしました。時間をおいて再度お試しください。";

export const SaveAccount = 'Account';
export const SaveChat = 'Chat';

export const LOCALSTORAGE_KEYS = {
    isMenuOpen : 'isMenuOpen',
    previewUrl : 'previewUrl',
    currentHTML : 'currentHTML',
    serviceType : 'serviceType',
    opsPromptDraft : 'opsPromptDraft',
    opsPromptVerCollapsed : 'opsPromptVerCollapsed',
    opsPromptSplit : 'opsPromptSplit',
    opsPromptOutline : 'opsPromptOutline',
}

export const INITIALIZE_STATE = {
    before                      : 1,
    ready                       : 2,
    tUserFetching               : 3,
    tUserFetchComplete          : 4,
    tAccountFetching            : 7,
    tAccountFetchComplete       : 8,
    allComplete                 : 9,
    pageDataFetching            : 10,
    pageDataFetchComplete       : 11,
}

export const fileType = {
    "image/jpeg"        : 1,
    "image/png"         : 1,
    "image/svg+xml"     : 1,
    "video/mp4"         : 2,
    "video/webm"        : 2,
    "video/x-msvideo"   : 2,
    "image/gif"         : 3,
    "application/pdf"   : 4,
}


// 権限は数値が大きいほど強い。段階の追加は AUTH_RANK_LIST にも反映すること
// サーバー側 api/api/configs/constants.py の USER_AUTH_TYPE_* と同期させること。
export const USER_AUTH_TYPE_READONLY = 1;
export const USER_AUTH_TYPE_NORMAL = 5;
export const USER_AUTH_TYPE_ADMIN = 20;
export const USER_AUTH_TYPE_OPERATOR = 99;

export const UserAuthType = {
    [USER_AUTH_TYPE_READONLY] :"一般（読み取りのみ）",
    [USER_AUTH_TYPE_NORMAL]   :"一般",
    [USER_AUTH_TYPE_ADMIN]    :"管理者",
    [USER_AUTH_TYPE_OPERATOR] :"運営",
}

// 権限の強さ順（弱→強）
// 機微フィールドの閲覧判定はこのリストの順序のみを根拠とし、authの数値の大小には依存しない。
// 新しい権限を追加したら必ずここに位置づけを書くこと。書かなければ常に不許可（fail close）となる。
// サーバー側 api/api/configs/admin_auth.py の auth_rank_list と同期させること。
export const AUTH_RANK_LIST = [
    USER_AUTH_TYPE_READONLY,
    USER_AUTH_TYPE_NORMAL,
    USER_AUTH_TYPE_ADMIN,
    USER_AUTH_TYPE_OPERATOR,
]

// 機微フィールド名（サーバー側 admin_auth.py の FIELD_* と対応）
export const FIELD_ADJUST_QUESTION = "adjust_question";

// 機微フィールド毎の必要権限レベル
// AUTH_RANK_LIST上でこのレベル以上の権限であれば閲覧可能。フィールドを増やす場合はここに1行追加する。
// サーバー側 admin_auth.py の field_required_auth と同期させること。
export const FIELD_REQUIRED_AUTH = {
    [FIELD_ADJUST_QUESTION] : USER_AUTH_TYPE_OPERATOR,
}

// ユーザー管理（サブアカウント管理）の必要権限レベル(※サーバー側 admin_auth.py の ACCOUNT_MANAGE_REQUIRED_AUTH と同期させること。)
export const ACCOUNT_MANAGE_REQUIRED_AUTH = USER_AUTH_TYPE_ADMIN;

// 運営ツール（プロンプト管理・外見動画管理）の必要権限レベル(※サーバー側 admin_auth.py の OPS_TOOL_REQUIRED_AUTH と同期させること。)
export const OPERATOR_TOOL_REQUIRED_AUTH = USER_AUTH_TYPE_OPERATOR;

// デモページ作成を使える環境（デモは v2 サーバーでのみ配信される。サーバー側 DemoPage.AVAILABLE_ENVIRONMENTS と同期させること。）
export const IS_DEMO_PAGE_AVAILABLE = ['localhost', 'development'].includes(ENV);

// 更新系の操作（保存・削除・アップロード・生成）に必要な権限レベル
// これ未満（＝一般（読み取りのみ））は、閲覧はできるが更新系のUIを全て非活性にする。
// サーバー側 admin_auth.py の deny_auth_list と対で運用すること。画面側はUX目的で、実際の拒否はサーバーが行う。
export const UPDATE_REQUIRED_AUTH = USER_AUTH_TYPE_NORMAL;

export const PAGE_ITEM_COUNT = {
    UserInfo : 10,
}

// アセットタイプ
export const ASSET_TYPE = {
    IDLE : 1,
    TALK : 2,
    JSON : 3,
    DOC  : 4,
    RAG_TEXT  : 5,
    USER_PROMPT : 8,
    IDLE_MINI : 10,
    NOD : 11,
    THINK : 12,
    THINK2 : 13,
}

// アセットタイプ
export const RAG_OPERATION_TYPE = {
    ADD : 1,
    DELETE : 2,
}

// 学習タイプ
export const RAG_TRAINED_TYPE = {
    NOT_TRAINED : 0,
    FIXED_CHUNK : 1,
    VARIABLE_CHUNK : 2
}

// 学習の実行状態(t_asset.process_status。完了は RAG_TRAINED_TYPE で表す)
export const RAG_TRAIN_STATUS = {
    NONE : 0,
    WAITING : 1,
    RUNNING : 2,
    FAILED : 99,
}

// 学習の実行状態を確認する間隔(ミリ秒)
export const RAG_TRAIN_POLL_INTERVAL_MS = 4000

// アセットタイプ
export const GENDER_TYPE = {
    MALE : 1,
    FEMALE : 2,
}

// パスワード最小文字数
export const USER_PASSWORD_MIN_LENGTH = 8

// 入力値の最大文字数(※サーバー側 api/api/configs/constants.py と同期させること。)
export const USER_PASSWORD_MAX_LENGTH = 32
export const USER_NAME_MAX_LENGTH = 64
export const MAIL_ADDRESS_MAX_LENGTH = 64

// ファイルアップロード時の許可拡張子
export const ACCEPT_VIDEO_EXTENSION_LIST =[".wmv", ".mp4", ".avi", ".mov", ".webm"]
export const ACCEPT_DOC_EXTENSION_LIST =[".pdf", ".doc", ".docx", ".html"]
export const ACCEPT_TEST_DATA_EXTENSION_LIST =[".csv"]

// アップロードできる1ファイルあたりの最大サイズ(※nginx/nginx.conf の client_max_body_size と同期させること。)
export const MAX_UPLOAD_FILE_SIZE = 100 * 1024 * 1024

// 日付表示設定
export const RANGE_TYPE_SHORT  = 7;
export const RANGE_TYPE_MIDDLE = 28;
export const RANGE_TYPE_LONG   = 60;
export const RANGE_TYPE_CUSTOM = 999;

export const RangeLabelType = {
    [RANGE_TYPE_SHORT]   :"過去7日間",
    [RANGE_TYPE_MIDDLE]  :"過去28日間",
    [RANGE_TYPE_LONG]    :"過去60日間",
    [RANGE_TYPE_CUSTOM]  :"カスタム",
}

// ログファイルをDLする際に設定する名前
export const CHAT_LOG_CSV_FILE_NAME = 'ログデータ';

// 操作ログファイルをDLする際に設定する名前
export const ACTION_LOG_CSV_FILE_NAME = '操作ログデータ';

// タグ名
export const SCRIPT_TAG_BASE_STR = "<script src='#PRIZMO_JS_PATH#' defer data-conf-url='#REPLACE_JSON_PATH#' charset='UTF-8'></script>"
// タグ内の置き換え指定文字
export const SCRIPT_TAG_REPLACE_STR_JS_PATH ="#PRIZMO_JS_PATH#"
export const SCRIPT_TAG_REPLACE_STR ="#REPLACE_JSON_PATH#"

// タグ名
export const TARGET_TAG_BASE_STR = "<div id='#REPLACE_TARGET_PATH#' style='all:unset; width:100%; height:100%; position:relative;'></div>"
// タグ内の置き換え指定文字
export const TARGET_TAG_REPLACE_STR ="#REPLACE_TARGET_PATH#"

// サービスタイプ
export const SERVICE_TYPE_DEFAULT = 0;
export const SERVICE_TYPE_RECRUITING = 1;
export const SERVICE_TYPE_PRODUCT = 2;
export const SERVICE_TYPE_FACILITY = 3;
export const SERVICE_TYPE_CHOICE = 4;

// サービスタイプのラベル
export const SERVICE_TYPE_LABELS = {
    [SERVICE_TYPE_DEFAULT] : "default",
    [SERVICE_TYPE_RECRUITING] : "recruiting",
    [SERVICE_TYPE_PRODUCT] : "product",
    [SERVICE_TYPE_FACILITY] : "facility",
    [SERVICE_TYPE_CHOICE] : "choice",
}